import React from "react";

import { Col, Container, Image, Row } from "react-bootstrap";

import faArea from "@/assets/icons/faArea.svg";
import faLongLasting from "@/assets/icons/faLongLasting.svg";
import faMouse from "@/assets/icons/faMouse.svg";
import faMuscle from "@/assets/icons/faMuscle.svg";
import FaVirus from "@/assets/icons/faVirus.svg";
import BannerComponent from "@/components/Banner.component";
import DocumentComponent from "@/components/Document.component";
import ScheduleComponent from "@/components/Schedule.component";
import { getUrlLangPrefix } from "@/utils/Local";

import i18n from "../i18n";

const PartnershipPage = () => {
  const { t } = i18n;
  const langPrefix = getUrlLangPrefix();
  const features = [
    {
      icon: (
        <img
          alt={t("Built by the Community")}
          className="w-100"
          src={faLongLasting}
        />
      ),
      title: t("Built by the Community"),
      note: t("For the community"),
    },
    {
      icon: <img alt={t("Customizable")} src={faArea} />,
      title: t("Customizable"),
      note: t("Designed for your needs"),
    },
    {
      icon: <img alt={t("Build Tough")} src={faMuscle} />,
      title: t("Build Tough"),
      note: t("Withstand heavy impact"),
    },
    {
      icon: <img alt={t("Mold-Free")} src={FaVirus} />,
      title: t("Mold-Free"),
      note: t("Contains zero organic material"),
    },
    {
      icon: <img alt={t("Rodent Resistant")} src={faMouse} />,
      title: t("Rodent Resistant"),
      note: t("Built to keep pests out"),
    },
  ];

  return (
    <React.Fragment>
      <DocumentComponent title={t("Durable Homes Built With Communities")} />
      <BannerComponent
        description="Delivering resilient, high-performance housing solutions through collaboration, local training, and long-term partnerships."
        title={t("Durable Homes Built With Communities")}
      />
      <Container className="partnershipPageContainer">
        <Row className="pt-2 pb-2 mt-2 mt-lg-0">
          <Col
            className="mt-4 mt-lg-0 order-2 order-lg-1 text-center"
            lg={6}
            xs={12}
          >
            <Image
              rounded
              alt={t("Durable Homes Built With Communities")}
              className="mw-100"
              loading="lazy"
              src="/images/projects/Amherst.png"
            />
          </Col>

          <Col
            className="order-1 order-lg-2 text-center text-lg-start"
            lg={6}
            xs={12}
          >
            <div className="flexContainer">
              <h2 className="w-100">{t("What We Do")}</h2>
              <p>
                {t(
                  "At PakVille, we believe long-term housing solutions come from collaboration, local involvement, and community leadership.",
                )}
              </p>
              <p>
                {t(
                  "We work alongside Indigenous communities to better understand local realities, climate challenges, and cultural priorities before proposing solutions.",
                )}
              </p>
              <p>
                {t(
                  "Our approach combines durable, high-performance building systems with hands-on training and local workforce development, helping communities build capacity while creating healthier and more resilient homes.\n",
                )}
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <Container
        fluid
        className="mt-2 mt-lg-5 pt-4 pb-4 partnershipPageContainer"
        style={{ backgroundColor: "#F9F8F8" }}
      >
        <Container>
          <Row className="text-center text-lg-start">
            <Col lg={6} xs={12}>
              <h2 className="">{t("Partnership & Impact")}</h2>
              <p>
                {t(
                  "PakVille is proud to partner with The Steven Low Foundation to support sustainable housing initiatives for Indigenous communities across Canada.",
                )}
              </p>
              <p>
                {t(
                  "Together, we aim to advance housing solutions that are durable, culturally respectful, and designed for long-term community resilience.",
                )}
              </p>
              <p className="m-0">
                {t(
                  "PakVille also supports The Steven Low Foundation through contributions that help advance Indigenous-led initiatives, including community wellbeing, reconciliation efforts, and sustainable housing solutions.",
                )}
              </p>
            </Col>

            <Col className="mt-4 mt-lg-0 text-center" lg={6} xs={12}>
              <img
                alt={t("The Steven Low Foundation - La Fondation Steven Low")}
                className="mw-80 mb-4"
                src="/images/partners/SLF-logo.png"
              />
              <p className="text-center text-lg-start">
                “Real change happens when solutions are built with communities,
                not for them.”
              </p>
              <i className="text-center text-lg-start">
                — Veronica Low, The Steven Low Foundation
              </i>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container className="partnershipPageContainer">
        <Row className="mt-5">
          <Col className="p-0 m-0">
            <Container className="flexContainer">
              <Row className="w-100">
                <Col xs={12}>
                  <h2 className="text-center text-lg-start">
                    {t("Why choose PakVille")}
                  </h2>
                </Col>
              </Row>

              <div className="horizontal-content-container">
                {features.map((feature) => (
                  <div key={feature.title} className="featureContainer">
                    <div className="svgContainer mb-0">{feature.icon}</div>
                    <h3>{feature.title}</h3>
                    <p>{feature.note}</p>
                  </div>
                ))}
              </div>
            </Container>
          </Col>
        </Row>
      </Container>

      <ScheduleComponent
        contactUsButtonLabel={t("Start a Conversation")}
        shouldRenderReserveModal={false}
        title={t("Let’s Build Together")}
        description={t(
          "We welcome conversations with Indigenous communities, housing organizations, and project partners looking to explore durable and sustainable housing solutions",
        )}
      />
    </React.Fragment>
  );
};

export default PartnershipPage;
